// plugins
import Choices from '../../../../assets/vendor/choices.js/public/assets/scripts/choices.js';
import lightgallery from '../../../../assets/vendor/lightgallery/lightgallery.min.js';
import video from '../../../../assets/vendor/lightgallery/lib/plugins/video/lg-video';
import '../../../../assets/vendor/vanilla-js-tooltip-master/scripts/vanilla-js-tooltip';
import Cookies from '../../../../assets/vendor/js-cookie/dist/js.cookie.mjs';
 
// local
import Header from './partials/header';
import ButtonSlider from './partials/button-slider';
import DateSlider from './partials/date-slider';
import Collapsible from './partials/collapsible';
import Number from './partials/number';
import Modal from './partials/modals';
import ScrollTo from './partials/scroll-to';
import Animate from './partials/animate';
import ThemeSwitcher from './partials/theme-switcher';
import Newsletter from './partials/newsletter';
import Form from './partials/form';
import IngredientCalculator from './partials/ingredient-calculator';
import RecipeContent from './components/recipe-content';
import RecipeClipboard from './components/recipe-clipboard';
import RecipeIntroAd from './components/recipe-intro-ad';
import RecipeVideo from "./components/recipe-video";
import AjaxData from './partials/ajax-data';
import Login from './partials/login';
import PasswordReset from './partials/password-reset';
import PasswordRecovery from './partials/password-recovery';
import ChangePassword from './partials/change-password';
import Profile from './partials/profile';
import Logout from './partials/logout';
import {LikeToggle, LikeLabel} from './partials/like-toggle';
import Rating from './partials/rating';
import SearchSuggestionForm from './components/search-suggestion';
import ReadingCollapsable from './partials/reading-collapsable';
import StickyElement from './partials/sticky-element';
import FloatingButton from './partials/floating-button';
import ProgramCta from './components/program-cta';
import PoiView from './components/poi-view';

import TVGuide from "./components/tv-guide";
import './components/advent-canvas';
import AdventCalender from "./components/advent-calender";'./components/advent-calender';
import './partials/lazy-load-observer'; 
import EventEpisodeList from "./components/event-episode-list";
import LinkTo from "../../../studio100-3/assets/js/partials/link-to";
import CookingView from "./partials/cooking-view";
import RecipePrint from "./partials/recipe-print";

window.initDom = ($wrapper) => {
    $wrapper.querySelectorAll('[data-button-slider]').forEach( $slider => (new ButtonSlider($slider).init()));
    $wrapper.querySelectorAll('[data-date-slider]').forEach( $slider => (new DateSlider($slider).init()));
    $wrapper.querySelectorAll('[data-collapsible]').forEach( $collapsible => (new Collapsible($collapsible)));
    $wrapper.querySelectorAll('[data-number]').forEach( $number => (new Number($number)));
    $wrapper.querySelectorAll('[data-modal]').forEach( $modal => (new Modal($modal)));
    $wrapper.querySelectorAll('a[href^="#"]').forEach(link => (new ScrollTo(link)));
    $wrapper.querySelectorAll('[data-animate]').forEach(link => (new Animate(link)));
    $wrapper.querySelectorAll('[data-theme-switcher]').forEach($el => (new ThemeSwitcher($el)));
    $wrapper.querySelectorAll('[data-recipe-content]').forEach($el => (new RecipeContent($el)));
    $wrapper.querySelectorAll('[data-recipe-clipboard]').forEach($el => (new RecipeClipboard($el)));
    //$wrapper.querySelectorAll('[data-recipe-intro]').forEach($el => (new RecipeIntroAd($el))); // @deprecated, are separate blocks now
    $wrapper.querySelectorAll('[data-block-type="recipe-video"]').forEach($el => (new RecipeVideo($el)));
    $wrapper.querySelectorAll('[data-block-type="recipe-content"],[data-block-type="recipe-cooking-view"]').forEach($el => (new IngredientCalculator($el)));
    $wrapper.querySelectorAll('form').forEach($el => (new Form($el)));
    $wrapper.querySelectorAll('[data-newsletter-form]').forEach( $newsletter => (new Newsletter($newsletter)));
    $wrapper.querySelectorAll('[data-login-form]').forEach( $form => (new Login($form)));
    $wrapper.querySelectorAll('[data-reset-password-form]').forEach( $form => (new PasswordReset($form)));
    $wrapper.querySelectorAll('[data-password-recovery-form]').forEach( $form => (new PasswordRecovery($form)));
    $wrapper.querySelectorAll('[data-change-password-form]').forEach( $form => (new ChangePassword($form)));
    $wrapper.querySelectorAll('[data-profile-form]').forEach( $form => (new Profile($form)));
    $wrapper.querySelectorAll('[data-logout]').forEach( $form => (new Logout($form)));
    $wrapper.querySelectorAll('[data-toggle-like]').forEach( $el => (new LikeToggle($el)));
    $wrapper.querySelectorAll('[data-like-label]').forEach( $el => (new LikeLabel($el)));
    $wrapper.querySelectorAll('[data-rating]').forEach( $el => (new Rating($el)));
    $wrapper.querySelectorAll('form#\\9xJ42').forEach( $el => (new SearchSuggestionForm($el)));
    $wrapper.querySelectorAll('[data-floating-button]').forEach( $el => (new FloatingButton($el)));
    $wrapper.querySelectorAll('[data-advent-calender-wrapper]').forEach($el => new AdventCalender($el));
    $wrapper.querySelectorAll('[data-block-type="event-episode-list"]').forEach($el => new EventEpisodeList($el));
    $wrapper.querySelectorAll('[data-block-type="program-detail"]').forEach($el => (new ProgramCta($el)));
    $wrapper.querySelectorAll('[data-block-type="tv-guide"]').forEach($el => (new TVGuide($el)));
    $wrapper.querySelectorAll('[data-block-type="recipe-cooking-view"]').forEach($el => (new CookingView($el)));
    $wrapper.querySelectorAll('[data-block-type="poi-detail"]').forEach($el => (new PoiView($el)));
    $wrapper.querySelectorAll('[data-href]').forEach($el => (new LinkTo($el)));
    $wrapper.querySelectorAll('[data-recipe-print]').forEach($el => (new RecipePrint($el)));
    // Collapsable is a variation on expandable that can be initiated in the wysiwyg
    $wrapper.querySelectorAll('.collapsable-trigger').forEach($el => new ReadingCollapsable($el));
    $wrapper.querySelectorAll('[data-dropdown]').forEach($select => {
        (new Choices($select, {
                searchEnabled: false,
                itemSelectText: "",
                placeholder: true,
                removeItemButton: $select.getAttribute('multiple') !== null,
                classNames: {
                    containerOuter: 'choices ' + $select.classList.toString()
                }
            }
        ));
    });

    $wrapper.querySelectorAll('[data-gallery]').forEach($el => {
        if(window.innerWidth >= 576) {
            lightgallery( $el, {
                plugins: [video],
                speed: 500,
                download: false,
            });
        } else {
            $el.addEventListener('click', (e) => e.preventDefault())
        }
    })

    $wrapper.querySelectorAll('[data-sticky-container]').forEach($element => new StickyElement($element));

    /**
     * Wrap videos in reading in video container
     */
    $wrapper.querySelectorAll('.reading iframe[src*="youtube.com"], .reading iframe[data-cmp-src*="youtube.com"]').forEach(($el) => {
        if (!$el.parentElement.classList.contains('.video-container')) {

            let wrapper = document.createElement('div');
            wrapper.classList.add('video-container')
            $el.parentNode.insertBefore(wrapper, $el);
            wrapper.appendChild($el);
        }
    });

    (new AjaxData($wrapper)).updateDom();
}


// Cross-browser event listener
function addEvent(el, evt, fn) {
    if (el.addEventListener) {
        el.addEventListener(evt, fn);
    } else if (el.attachEvent) {
        el.attachEvent('on' + evt, function (evt) {
            fn.call(el, evt);
        });
    } else if (typeof el['on' + evt] === 'undefined' || el['on' + evt] === null) {
        el['on' + evt] = function (evt) {
            fn.call(el, evt);
        };
    }
}

(function() {
    window.initDom(document);
    document.querySelectorAll('[data-header]').forEach( $header => (new Header($header)));

    // scroll to
    if(window.location.hash && !window.location.hash.startsWith("#search") && document.querySelector(window.location.hash)) {
        document.querySelector(window.location.hash).scrollIntoView({
            behavior: 'smooth'
        });
    }

    // add event listener for iframe events
    addEvent(window, 'message', function (message) {
        try {
            var data = JSON.parse(message.data);
            var dataLayer = window.dataLayer || (window.dataLayer = []);
            if (data.event) {
                dataLayer.push({
                    'event': data.event,
                    'postMessageData': data
                });
            }
        } catch (e) {
        }
    });

    const showModal = () => {
        setTimeout(() => {
            const $modalOnLoad = document.querySelector('[data-modal][data-modal-onload]');

            if ($modalOnLoad && ! Cookies.get($modalOnLoad.dataset.modal)) {
                Cookies.set($modalOnLoad.dataset.modal, 1, {expires: 1});
                (new Modal($modalOnLoad)).openModal();
            }
        }, 500) // we need to add a timeout otherwise the accept click closes the modal
    }
    __cmp("addEventListener",["consent",showModal,false],null);
})();
